var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from "react";
import { string, bool, func, any } from "prop-types";

import { HelpTooltip } from "../../components/HelpTooltip";

import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

var SelectWidget = (_temp2 = _class = function (_PureComponent) {
  _inherits(SelectWidget, _PureComponent);

  function SelectWidget() {
    var _temp, _this, _ret;

    _classCallCheck(this, SelectWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
      values: []
    }, _this.parseFetchedValues = function (values) {
      var _this$props = _this.props,
          schema = _this$props.schema,
          metadata = _this$props.schema.metadata;


      _this.setState({
        fetchedValues: values.map(function (item) {
          var name = item[metadata.mappingName],
              value = item[metadata.mappingValue];


          return { name: name, value: value };
        })
      });
    }, _this.handleChange = function (_ref) {
      var value = _ref.target.value;
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          options = _this$props2.options;

      onChange(value ? value : options.emptyValue);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SelectWidget.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var schema = this.props.schema;
    var _props$options = this.props.options,
        headers = _props$options.headers,
        disableOnLoadIntegration = _props$options.disableOnLoadIntegration;


    if (!disableOnLoadIntegration) {
      !!schema.service && fetch(schema.operation, { method: "GET", headers: headers || {} }).then(function (res) {
        return res.json();
      }).then(function (json) {
        return _this2.parseFetchedValues(json);
      }).catch(function (e) {
        return console.log(e);
      });
    }
  };

  SelectWidget.prototype.render = function render() {
    var _props = this.props,
        _props$value = _props.value,
        value = _props$value === undefined ? "" : _props$value,
        label = _props.label,
        _props$schema = _props.schema,
        items = _props$schema.items,
        readonly = _props$schema.readonly,
        metadata = _props$schema.metadata,
        rest = _objectWithoutProperties(_props, ["value", "label", "schema"]);

    var fetchedValues = this.state.fetchedValues;


    return React.createElement(
      FormControl,
      { fullWidth: true, disabled: metadata.readonly },
      React.createElement(HelpTooltip, { help: metadata.help }),
      typeof label !== "undefined" && React.createElement(
        InputLabel,
        null,
        label + (metadata.required ? " *" : "")
      ),
      React.createElement(
        Select,
        { value: value, onChange: this.handleChange },
        React.createElement(MenuItem, { value: "" }),
        (fetchedValues || items.titleMap).map(function (item) {
          return React.createElement(
            MenuItem,
            { key: item.value, value: item.value },
            item.name
          );
        })
      )
    );
  };

  return SelectWidget;
}(PureComponent), _class.defaultProps = {
  required: false,
  disabled: false,
  readonly: false,
  autofocus: false
}, _temp2);
SelectWidget.propTypes = process.env.NODE_ENV !== "production" ? {
  id: string.isRequired,
  placeholder: string,
  value: any,
  required: bool,
  disabled: bool,
  readonly: bool,
  autofocus: bool,
  onChange: func,
  onBlur: func,
  onFocus: func
} : {};


export default SelectWidget;